import { updateObject } from "utils/helpers/updateObject";
import { initialState, PackagesState } from "./state";
import {
  actionTypes,
  CreatePackageFailureAction,
  CreatePackageRequestAction,
  CreatePackageSuccessAction,
  DeletePackageFailAction,
  DeletePackageSuccessAction,
  FetchPackagesFailureAction,
  FetchPackagesRequestAction,
  FetchPackagesSuccessAction,
  PackageActions,
  ResetPackage,
  stateStatusType,
  UpdatePackageFailAction,
  UpdatePackageSuccessAction,
} from "./actionType";

// fetchUsersRequest
const fetchPackagesRequest = (
  state: PackagesState,
  action: FetchPackagesRequestAction
) => {
  return updateObject(state, {
    fetchPackagesState: {
      ...state.fetchPackagesState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const fetchPackagesSuccess = (
  state: PackagesState,
  action: FetchPackagesSuccessAction
) => {
  return updateObject(state, {
    fetchPackagesState: {
      ...state.fetchPackagesState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      packages: action.payload,
    },
  });
};

const fetchPackagesFail = (
  state: PackagesState,
  action: FetchPackagesFailureAction
) => {
  return updateObject(state, {
    fetchPackagesState: {
      ...state.fetchPackagesState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
      packages: null,
    },
  });
};

//create package
const createPackageSuccess = (
  state: PackagesState,
  action: CreatePackageSuccessAction
) => {
  const newPackages = state.fetchPackagesState.packages ?? [];
  return updateObject(state, {
    createPackageState: {
      ...state.createPackageState,
      packages: {
        ...action.payload,
      },
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
    },
    fetchPackagesState: {
      ...state.fetchPackagesState,
      packages: [...newPackages, action.payload],
    },
  });
};

const createPackageFail = (
  state: PackagesState,
  action: CreatePackageFailureAction
) => {
  return updateObject(state, {
    createPackageState: {
      ...state.createPackageState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
    fetchPackagesState: {
      ...state.fetchPackagesState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};

//Update Package
const updatePackageSuccess = (
  state: PackagesState,
  action: UpdatePackageSuccessAction
) => {
  const newPackage =
    state.fetchPackagesState?.packages?.map((item) =>
      item.id === action.payload.id ? action.payload : item
    ) ?? [];
  return updateObject(state, {
    updatePackageState: {
      ...state.updatePackageState,
      isLoading: false,
      error: null,
    },
    fetchPackagesState: {
      ...state.fetchPackagesState,
      state: stateStatusType.SUCCESS,
      packages: [...newPackage],
    },
  });
};
const UpdatePackageFail = (
  state: PackagesState,
  action: UpdatePackageFailAction
) => {
  return updateObject(state, {
    updatePackageState: {
      ...state.updatePackageState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
    fetchPackagesState: {
      ...state.fetchPackagesState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};

//Delete Package
const deletePackageSuccess = (
  state: PackagesState,
  action: DeletePackageSuccessAction
) => {
  const packages = state.fetchPackagesState?.packages ?? [];
  const newPackage = packages.filter((item) => item.id !== action.payload);
  return updateObject(state, {
    deletePackageState: {
      ...state.deletePackageState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
    },
    fetchPackagesState: {
      ...state.fetchPackagesState,
      packages: [...newPackage],
    },
  });
};

const deletePackageFail = (
  state: PackagesState,
  action: DeletePackageFailAction
) => {
  return updateObject(state, {
    deletePackageState: {
      ...state.deletePackageState,
      isLoading: false,
      error: action.payload,
    },
    fetchPackagesState: {
      ...state.fetchPackagesState,
      isLoading: false,
      error: action.payload,
    },
  });
};

const resetCoupon = (state: PackagesState, action: ResetPackage) => ({
  ...state,
  createPackageState: { ...initialState.createPackageState },
  updatePackageState: { ...initialState.updatePackageState },
  deletePackageState: { ...initialState.deletePackageState },
});

const fetchPackagesReducer = (state = initialState, action: PackageActions) => {
  switch (action.type) {
    case actionTypes.FETCH_PACKAGES_REQUEST:
      return fetchPackagesRequest(state, action);
    case actionTypes.FETCH_PACKAGES_SUCCESS:
      return fetchPackagesSuccess(state, action);
    case actionTypes.FETCH_PACKAGES_FAIL:
      return fetchPackagesFail(state, action);
    case actionTypes.CREATE_PACKAGE_SUCCESS:
      return createPackageSuccess(state, action);
    case actionTypes.CREATE_PACKAGE_FAIL:
      return createPackageFail(state, action);
    case actionTypes.UPDATE_PACKAGE_SUCCESS:
      return updatePackageSuccess(state, action);
    case actionTypes.UPDATE_PACKAGE_FAIL:
      return UpdatePackageFail(state, action);
    case actionTypes.DELETE_PACKAGE_SUCCESS:
      return deletePackageSuccess(state, action);
    case actionTypes.DELETE_PACKAGE_FAIL:
      return deletePackageFail(state, action);
    case actionTypes.RESET_PACKAGE:
      return resetCoupon(state, action);
    default:
      return state;
  }
};

export default fetchPackagesReducer;
